var _rect, _circle, _path, _path2, _path3, _circle2, _circle3, _circle4, _rect2, _rect3, _path4, _path5, _circle5, _circle6, _ellipse, _ellipse2, _ellipse3, _path6, _ellipse4, _circle7, _ellipse5, _circle8, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle9, _circle10, _defs, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#6b6f45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#7c805b",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#7d7a50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L60 98L72 88L72 84L60 92L48 84Z",
    fill: "#646140"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98L60 124",
    stroke: "#646140",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 104,
    r: 1.7,
    fill: "#c9b27a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 112,
    r: 1.7,
    fill: "#c9b27a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 120,
    r: 1.7,
    fill: "#c9b27a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 102,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#646140",
    opacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 102,
    width: 14,
    height: 12,
    rx: 2,
    fill: "#646140",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 98L34 100M94 98L86 100",
    stroke: "#c9b27a",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#a26b48"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#b97a52"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#b97a52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#b97a52"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#905f3f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48Q51 44 57 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48Q69 44 75 48",
    stroke: "#2a1d1a",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69L66 69",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39C28 19 44 11 60 11S92 19 92 39C84 44 36 44 28 39Z",
    fill: "#75794d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39C36 44 84 44 92 39",
    stroke: "#5b5e3c",
    strokeWidth: 3,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19C48 14 58 13 66 14",
    stroke: "#939674",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42L43 62Q46 80 60 80Q74 80 77 62L78 42",
    stroke: "#8a7a52",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 62,
    r: 1.8,
    fill: "#c9b27a"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 62,
    r: 1.8,
    fill: "#c9b27a"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait29);
export default __webpack_public_path__ + "static/media/player-portrait-29.9153232eac97a0897823b8ead0c0b8db.svg";
export { ForwardRef as ReactComponent };